import React, { useEffect, useState } from "react";
import "../../CustomerPreview.scss";
import { applicantCountConstant } from "../../../../config/constant";
import { formatDate } from "../../../../utilis/common-funtions";

const OtherApplicantDetails = ({ applicantData }) => {
  const [applicantList, setApplicantList] = useState([]);

  useEffect(() => {
    let obj = [];
    if (applicantData && applicantData?.applicant3 !== null) {
      obj.push(applicantData?.applicant3);
    }
    if (applicantData && applicantData?.applicant4 !== null) {
      obj.push(applicantData?.applicant4);
    }
    setApplicantList(obj);
  }, [applicantData]);

  return (
    <>
      {applicantList &&
        applicantList?.length > 0 &&
        applicantList.map((data, index) => {
          return (
            <div
              key={index}
              className={`otherApplicantDetails applicant${index + 3}`}
            >
              <div className="applicantDetailsCard">
                <div className="editTitleRow">
                  <div className="btnApplicantTop">
                    {index + 3}
                    <sup>
                      {applicantCountConstant?.numberKeys[index + 3]}
                    </sup>{" "}
                    Applicant
                  </div>
                </div>

                <div className="personalInformation marginBottom0">
                  <div className="informationDetails">
                    <h2 className="name">{`${
                      data?.personalDetails?.firstName
                    }${" "}${data?.personalDetails?.lastName}`}</h2>
                    <h3 className="titlePersonalHD">Personal Details</h3>
                    <div className="personalInfo width40">
                      <div className="personalInfoRow">
                        <label className="label150">First Name:</label>
                        <span>
                          {`${data?.personalDetails?.firstName}` || "N/A"}
                        </span>
                      </div>
                      <div className="personalInfoRow">
                        <label className="label150">Last Name:</label>
                        <span>
                          {`${data?.personalDetails?.lastName}` || "N/A"}
                        </span>
                      </div>
                      <div className="personalInfoRow">
                        <label className="label150">Contact Number:</label>
                        <span>
                          {`${data?.contactDetails?.countryCode}${data?.contactDetails?.contactNumber}` ||
                            "N/A"}
                        </span>
                      </div>
                      <div className="personalInfoRow">
                        <label className="label150">Email ID:</label>
                        <span>
                          {data?.contactDetails?.emailAddress || "N/A"}
                        </span>
                      </div>
                      <div className="personalInfoRow">
                        <label className="label150">Date of Birth:</label>
                        <span>  {data?.personalDetails?.dob  ? formatDate(data.personalDetails.dob)  : "N/A"}</span>
                      </div>
                      {data?.contactDetails?.panNumber !== null &&
                      data?.contactDetails?.panNumber?.length > 0 ? (
                        <div className="personalInfoRow">
                          <label className="label150">Pan Number:</label>
                          <span>
                            {data?.contactDetails?.panNumber || "N/A"}
                          </span>
                        </div>
                      ) : null}
                      {data?.contactDetails?.aadhaarNumber !== null &&
                      data?.contactDetails?.aadhaarNumber?.length > 0 ? (
                        <div className="personalInfoRow">
                          <label className="label150">Aadhaar Number:</label>
                          <span>
                            {data?.contactDetails?.aadhaarNumber || "N/A"}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};

export default OtherApplicantDetails;